// import hooks
import useMediaQuery from "@mui/material/useMediaQuery";
export const useMediaQueryHook = useMediaQuery;
export default useMediaQueryHook;
